import { render, staticRenderFns } from "./SupportFormModal.vue?vue&type=template&id=745736fc&"
import script from "./SupportFormModal.vue?vue&type=script&lang=ts&"
export * from "./SupportFormModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports